export type StationAudienceSizeParameters = {
  webStationId: string;
};

export type StationAudienceSizeResponse = {
  stationId: number;
  kind: 'audienceSize';
  data: {
    rows: number[];
  };
  columnHeader: {
    name: 'Audience Size';
    type: 'integer';
  }[];
};

export const fetchStationAudienceSize = async ({
  webStationId,
}: StationAudienceSizeParameters): Promise<StationAudienceSizeResponse> => {
  try {
    const resp = await fetch(
      `/api/proxy/v3/analytics/station/webStationId:${webStationId}/audienceSize`,
      {
        credentials: 'same-origin',
      }
    );

    if (resp.ok) {
      return resp.json();
    }

    throw new Error('could not fetch station audience size');
  } catch (err) {
    throw new Error(err.message);
  }
};
